import {
  Button,
  Content,
  FontAwesomeProIcon,
  Link,
  List,
  ListItem,
} from '@wienenergiegithub/ui-next';
import styles from './NotifySuccess.module.scss';
import React from 'react';
import PropTypes from 'prop-types';

const NotifySuccess = ({ bauvorhabenSite }) => (
  <>
    <List
      className={styles.container}
      icon={
        <FontAwesomeProIcon icon="check" role="presentation" type="regular" />
      }
      type="checkmark"
    >
      <ListItem className={styles.listItem} data-purpose="success-message">
        Vielen Dank für Ihr Interesse.
      </ListItem>
    </List>
    {!!bauvorhabenSite && (
      <>
        <Content className={styles.bauvorhabenInfo}>
          Wir bauen unser Versorgungsgebiet laufend aus – Überprüfen Sie hier,
          wo wir gerade für Sie arbeiten:
        </Content>
        <div className={styles.linkButton}>
          <Button
            isElevated
            render={
              <Link to={bauvorhabenSite?.url}>
                Zu den aktuellen Bauvorhaben
              </Link>
            }
          />
        </div>
      </>
    )}
  </>
);

NotifySuccess.propTypes = {
  bauvorhabenSite: PropTypes.shape({
    url: PropTypes.string,
  }),
};

export { NotifySuccess };
